function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons/Unplanned_disruption_noborder");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 350 0 350 350 0 350"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Unplanned_disruption_noborder",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  mask: "url(#mask-2)",
  cx: 175,
  cy: 175,
  r: 170
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.638522,168.082625 L154.638522,77.7012524 L195.361478,77.7012524 L195.361478,168.082625 L193.327924,213.809639 L156.671078,213.809639 L154.638522,168.082625 Z M153.877187,251.030253 C153.877187,239.060426 162.530266,230.292598 174.990022,230.292598 C187.458758,230.292598 196.122813,239.060426 196.122813,251.030253 C196.122813,263.519943 187.458758,272.298748 174.990022,272.298748 C162.530266,272.298748 153.877187,263.519943 153.877187,251.030253 L153.877187,251.030253 Z",
  id: "Fill-4",
  fill: "#E05730",
  mask: "url(#mask-2)"
})));

const SvgIconsUnplannedDisruption = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "350px",
    height: "350px",
    viewBox: "0 0 350 350",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconsUnplannedDisruption, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icons-unplanned-disruption.51a013b7.svg";
export { ForwardRef as ReactComponent };